import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../static/dashboard/logo.svg';
import Signout from '../../static/dashboard/signout.svg';

import MobileMenu from '../../static/dashboard/menu.svg';

export default function DashboardTopNav({ history, mobileActive, handleMobileMenu, handleLogOut }) {

    const currentPath = history.location.pathname;

    return (
        <>
            <div className={`top-nav ${currentPath === '/dashboard/paymentfailed' ? 'no-logo' : ''}`}>
                <Link
                to="/"
                className="logo-wrapper">
                    <img 
                    className="logo" 
                    src={Logo} 
                    alt="Salewave logo wave"/>
                </Link>

                <div 
                className="signout"
                onClick={(e) => {
                    handleLogOut(e);
                    history.push('/')}}>
                    <img 
                    className="signout-button" 
                    src={Signout} 
                    alt="Signout button"/>
                    <span>Sign Out</span>
                </div>
                <img 
                onClick={handleMobileMenu}
                className="mobile-menu-button"
                src={MobileMenu} 
                alt="Menu"/>
            </div>
           
        </>
    )
}